module.exports = __webpack_public_path__ + "img/b44e051.jpg";